export const TzInvariantDate = (d: Date) => {
  const date = new Date(d);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0);
}

export const truncate = (d: Date) => {
  d.setSeconds(0);
  d.setMilliseconds(0);
  return d;
}
